export default {"src":"/_next/static/media/disc-wheels.f5a53d32.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};